module.exports = __webpack_public_path__ + "img/icon-register.5e9acf30.svg";